import { getAuthState } from '../hooks/useAuth';

let auth = getAuthState()

export const adsSendLeads = async (path: any, account_audience: any, con_token: any): Promise<any> => {
    try {
        auth = getAuthState()
        const response = await fetch(`https://f5gkmqm2yh.execute-api.us-east-1.amazonaws.com/prod/ads/audience`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': auth.idToken
            },
            body: JSON.stringify({
                'account_audience': account_audience,
                'path': path,
                'con_token': con_token
            })
        });
        if (!response.ok) {
            console.error(`Error: ${response.status} - ${response.statusText}`);
            return { error: `Falha em puxar contas: ${response.statusText}` };
        }
        const data = await response.json()
        return data;
    } catch (error) {
        console.error('Error updating connection:', error);
        return false;
    }
};